"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OfferPricingDetailsItem {
    constructor({ itemType, actionType, itemGroupName, itemGroupKey, amount, point, rewardAmount, rewardCurrency, }) {
        this.toJSON = () => ({
            itemType: this.itemType,
            actionType: this.actionType,
            itemGroupName: this.itemGroupName,
            itemGroupKey: this.itemGroupKey,
            amount: this.amount,
            point: this.point,
            rewardAmount: this.rewardAmount,
            rewardCurrency: this.rewardCurrency,
        });
        this.itemType = itemType;
        this.actionType = actionType;
        this.itemGroupName = itemGroupName;
        this.itemGroupKey = itemGroupKey;
        this.amount = amount;
        this.point = point;
        this.rewardAmount = rewardAmount;
        this.rewardCurrency = rewardCurrency;
    }
}
OfferPricingDetailsItem.fromJSON = (json) => {
    const { itemType, actionType, itemGroupName, itemGroupKey, amount, point, rewardAmount, rewardCurrency, } = Object.assign({}, json);
    if (typeof itemType !== 'string')
        throw new Error('.itemType must be a string');
    if (typeof actionType !== 'string')
        throw new Error('.actionType must be a string');
    if (itemGroupName !== null && itemGroupName !== undefined && typeof itemGroupName !== 'string')
        throw new Error('.itemGroupName must be a string');
    if (itemGroupKey !== null && itemGroupKey !== undefined && typeof itemGroupKey !== 'string')
        throw new Error('.itemGroupKey must be a string');
    if (typeof amount !== 'number')
        throw new Error('.amount must be a string');
    if (typeof point !== 'number')
        throw new Error('.point must be a string');
    if (typeof rewardAmount !== 'number')
        throw new Error('.rewardAmount must be a string');
    if (typeof rewardCurrency !== 'string')
        throw new Error('.rewardCurrency must be a string');
    return new OfferPricingDetailsItem({
        itemType,
        actionType,
        itemGroupName,
        itemGroupKey,
        amount,
        point,
        rewardAmount,
        rewardCurrency,
    });
};
exports.default = OfferPricingDetailsItem;
